const CATEGORY_COLORS = {
  "JATOBÁ": "#895A2B",
  "MARFIM": "#E8CCA5",
  "IMBUIA": "#D29E17",
  "JACARANDÁ": "#440D0D",
  "JACARANDÁ PLUS": "#99111E",
};

const DEFAULT_COLOR = "#72B502";

const CATEGORIES_ORDER = [
  "JATOBÁ",
  "MARFIM",
  "IMBUIA",
  "JACARANDÁ",
  "JACARANDÁ PLUS",
];

function normalizeName(name) {
  if (!name) return "";
  return name
    .trim()
    .toUpperCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
}

function findCategory(categoryName) {
  var normalized = normalizeName(categoryName);
  return CATEGORIES_ORDER.find(
    function (cat) { return normalizeName(cat) === normalized; }
  );
}

function getCategoryColor(categoryName) {
  var match = findCategory(categoryName);
  return match ? CATEGORY_COLORS[match] : DEFAULT_COLOR;
}

function getCategoryIndex(categoryName) {
  var match = findCategory(categoryName);
  return match ? CATEGORIES_ORDER.indexOf(match) : -1;
}

function getTextColor(categoryName) {
  var match = findCategory(categoryName);
  if (match === "MARFIM" || match === "IMBUIA") return "#000";
  return "#fff";
}

export {
  CATEGORY_COLORS,
  CATEGORIES_ORDER,
  DEFAULT_COLOR,
  getCategoryColor,
  getCategoryIndex,
  getTextColor,
};
